import { connect } from "react-redux";
import { Button, CardContent, CircularProgress, Dialog, DialogContent, IconButton, Table, TableBody, TableCell, TableRow, Tooltip, Typography } from "@mui/material";
import { AddToQueue, BorderColor, Delete,  PictureAsPdf } from "@mui/icons-material";
import * as React from "react";
import { useEffect, useState } from "react";
import { errorToast } from "../../helpers/Notification";
import { getError} from "store/helpers/common_functions";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import OpenDocument from "helpers/openDocument";
import { getFileMime } from "helpers/Common_functions";
import DeleteDialog from "helpers/DeleteDialog";
import FormDialog from "helpers/FormDialog";

const AttachmentManager = ({ isWorklog, isSubTask, worklog, task, FetchDetails, taskId, openAttachment, systemSettings, loggedUser, onClose, onSuccess, worklogId }) => {
    const mainBackground = systemSettings?.mainBackground;

    const [fileView, setFileView] = useState(null);
    const [documentName, setDocumentName] = useState(null);
    const [open, setOpen] = React.useState(0);
    const [value, setValue] = React.useState({});
    const [id, setId] = React.useState();
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue(v => {
            v[name] = val;
            return { ...v };
        });
    }

    const loadAttachments = async () => {
        setIsLoading(true);
        const resp = await FetchDetails(isWorklog ? `/api/worklogs/attachment/list/${worklog.id}` : isSubTask ? `/api/task/attachment/subTask/list/${task.id}` : `/api/task/attachment/list/${taskId}`);
        if (resp.status) {
            if (isWorklog) {
                worklog.worklog_attachments = resp?.data?.worklogAttachments;
            } else {
                task.task_attachments = resp?.data?.taskAttachments;
            }
            setIsLoading(false);
        } else {
            errorToast(getError(resp));
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (openAttachment) loadAttachments();

    }, [openAttachment]);

    // Function to strip HTML tags
    const stripHtmlTags = (str) => {
        if (!str) return '';
        return str.replace(/<\/?[^>]+(>|$)/g, "");
    };

    const content = (
        <>
            <div>
                <Dialog maxWidth={'md'} fullWidth={true} open={fileView !== null} onClose={() => setFileView(null)}>
                    <DialogContent>
                        {fileView !== null && <OpenDocument
                            downloadable={true}
                            document={fileView}
                            name={documentName ?? 'Document'}
                            specialName={fileView}
                            type={"permission-doc"}
                            mimeType={getFileMime(fileView)} />}
                    </DialogContent>
                </Dialog>
                <DeleteDialog url={isWorklog ? `api/worklogs/attachment/${id}` : `/api/task/attachment/${id}`} open={deleteOpen} setOpen={setDeleteOpen} onSuccess={() => {
                    setOpen(0); onSuccess()
                    loadAttachments();
                }} title={'Delete Document'} />

                <FormDialog onSuccess={() => {
                    setOpen(0); onSuccess()
                    loadAttachments();
                }} url={
                    !isWorklog ? open === 1 ? '/api/task/attachment' : `/api/task/attachment/update/${id}`
                        : (open === 1 ? '/api/worklogs/attachment' : `/api/worklogs/attachment/update/${id}`)} fields={[
                            {
                                name: "name",
                                label: "Attachment Name",
                                type: "text",
                                value: value['name'],
                                required: true,
                                setValue: (val) => setValue0('name', val),

                            },
                            {
                                name: isSubTask ? "subTaskId" : "",
                                label: "Task",
                                type: "select",
                                values: [{ label: task?.name, value: task?.id }],
                                value: task?.id,
                                required: true,
                                disabled: true,
                                hidden: true,

                            },
                            {
                                name: isWorklog ? "worklogId" : "taskId",
                                label: "Task",
                                type: "select",
                                values: isWorklog
                                    ? [{ label: stripHtmlTags(worklog?.description), value: worklog?.id }] : [{ label: task?.name, value: isSubTask ? task?.taskId : task?.id }],
                                value: isWorklog ? worklog.id : isSubTask ? task?.taskId : task?.id,
                                required: true,
                                disabled: true,
                                hidden: true,

                            },

                            {
                                name: "attachment",
                                label: "Attachment",
                                type: "file-drag",
                                value: value['attachment'],
                                required: open === 1,
                                setValue: (val) => setValue0('attachment', val),
                            },

                        ]} open={open} setOpen={setOpen} title={open === 1 ? 'Create New Document' : 'Update Document'} />

                <div>
                <div className={"flex items-center"}>
              <div className={"flex-grow font-bold text-lg"}>
               
              </div>
              <IconButton onClick={
                () => {
                    setFileView(null);
                    onClose();
                    }
              }>
                <img
                  src={require("assets/icons/close.svg").default}
                  alt={"close"}
                />
              </IconButton>
            </div>
            <div className={"flex items-center"}>
                        <Button sx={
                            {
                                margin: '0 20px',
                                background: mainBackground,
                                color: 'white',
                                '&:hover': {
                                    background: mainBackground,
                                    color: 'white',
                                },
                            }
                        } startIcon={<AddToQueue />} variant={'contained'} onClick={() => setOpen(1)} >Add New</Button>
                </div>
                    <CardContent>
                        <Table>
                            <TableBody>
                                {
                                    isLoading ? <TableRow>
                                        <TableCell colSpan={2} className="text-center">
                                            <CircularProgress />
                                        </TableCell>
                                    </TableRow> :
                                        worklog && worklog?.worklog_attachments?.length > 0 ? worklog?.worklog_attachments?.map((v, index) => {
                                            return <TableRow key={index}>
                                                <TableCell>
                                                    <Tooltip title={v?.description}>
                                                        <Button startIcon={<PictureAsPdf />} onClick={() => {
                                                            setFileView(v.attachment);
                                                            setDocumentName(v?.name);
                                                        }}>
                                                            {v?.name}
                                                        </Button>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell>
                                                    <Tooltip title={'Edit'}>
                                                        <BorderColor
                                                            fontSize="small"
                                                            onClick={() => {
                                                                setOpen(2);
                                                                setId(v?.id);
                                                                setValue0('name', v.name);
                                                            }} />
                                                    </Tooltip>
                                                    <Tooltip title={'Delete'}>
                                                        <Delete fontSize="small" color={'error'} onClick={() => {
                                                            setDeleteOpen(true);
                                                            setId(v?.id);
                                                        }} />
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        }) : task && task?.task_attachments?.length > 0 ? task?.task_attachments?.map((v, index) => {
                                            return <TableRow key={index}>
                                                <TableCell>
                                                    <Tooltip title={v?.description}>
                                                        <Button startIcon={<PictureAsPdf />} onClick={() => {
                                                            setFileView(v.attachment);
                                                        }}>
                                                            {v?.name}
                                                        </Button>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell>
                                                    <Tooltip title={'Edit'}>
                                                        <BorderColor
                                                            fontSize="small"
                                                            onClick={() => {
                                                                setOpen(2);
                                                                setId(v?.id);
                                                                setValue0('name', v.name);
                                                            }} />
                                                    </Tooltip>
                                                    <Tooltip title={'Delete'}>
                                                        <Delete fontSize="small" color={'error'} onClick={() => {
                                                            setDeleteOpen(true);
                                                            setId(v?.id);
                                                        }} />
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        }) : <TableRow>
                                            <TableCell colSpan={2} className="text-center">
                                                {"No document found."}
                                            </TableCell>
                                        </TableRow>}
                            </TableBody>
                        </Table>
                    </CardContent>
                </div>

            </div>
        </>
    );

    return (
        <Dialog open={openAttachment} onClose={onClose} maxWidth='sm' fullWidth>
            
            <DialogContent>
                {content}
            </DialogContent>
        </Dialog>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentManager);
